export default {"src":"/_next/static/media/notes-empty.43a57b72.svg","height":154,"width":219,"blurWidth":0,"blurHeight":0};